import { render, staticRenderFns } from "./problem-four.vue?vue&type=template&id=20e5093c&"
import script from "./problem-four.vue?vue&type=script&lang=js&"
export * from "./problem-four.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports